import type { Coin } from '../types';

/**
 * Fallback coins list - Top 100 cryptocurrencies
 * Used when CoinGecko API is unavailable or rate-limited
 */
export const FALLBACK_COINS: Coin[] = [
  { id: 'bitcoin', symbol: 'BTC', name: 'Bitcoin' },
  { id: 'ethereum', symbol: 'ETH', name: 'Ethereum' },
  { id: 'tether', symbol: 'USDT', name: 'Tether' },
  { id: 'binancecoin', symbol: 'BNB', name: 'BNB' },
  { id: 'solana', symbol: 'SOL', name: 'Solana' },
  { id: 'usd-coin', symbol: 'USDC', name: 'USD Coin' },
  { id: 'ripple', symbol: 'XRP', name: 'XRP' },
  { id: 'staked-ether', symbol: 'STETH', name: 'Lido Staked Ether' },
  { id: 'cardano', symbol: 'ADA', name: 'Cardano' },
  { id: 'dogecoin', symbol: 'DOGE', name: 'Dogecoin' },
  { id: 'avalanche-2', symbol: 'AVAX', name: 'Avalanche' },
  { id: 'tron', symbol: 'TRX', name: 'TRON' },
  { id: 'chainlink', symbol: 'LINK', name: 'Chainlink' },
  { id: 'polkadot', symbol: 'DOT', name: 'Polkadot' },
  { id: 'polygon', symbol: 'MATIC', name: 'Polygon' },
  { id: 'wrapped-bitcoin', symbol: 'WBTC', name: 'Wrapped Bitcoin' },
  { id: 'shiba-inu', symbol: 'SHIB', name: 'Shiba Inu' },
  { id: 'dai', symbol: 'DAI', name: 'Dai' },
  { id: 'litecoin', symbol: 'LTC', name: 'Litecoin' },
  { id: 'uniswap', symbol: 'UNI', name: 'Uniswap' },
  { id: 'bitcoin-cash', symbol: 'BCH', name: 'Bitcoin Cash' },
  { id: 'cosmos', symbol: 'ATOM', name: 'Cosmos Hub' },
  { id: 'leo-token', symbol: 'LEO', name: 'LEO Token' },
  { id: 'ethereum-classic', symbol: 'ETC', name: 'Ethereum Classic' },
  { id: 'monero', symbol: 'XMR', name: 'Monero' },
  { id: 'stellar', symbol: 'XLM', name: 'Stellar' },
  { id: 'okb', symbol: 'OKB', name: 'OKB' },
  { id: 'hedera-hashgraph', symbol: 'HBAR', name: 'Hedera' },
  { id: 'filecoin', symbol: 'FIL', name: 'Filecoin' },
  { id: 'internet-computer', symbol: 'ICP', name: 'Internet Computer' },
  { id: 'aptos', symbol: 'APT', name: 'Aptos' },
  { id: 'arbitrum', symbol: 'ARB', name: 'Arbitrum' },
  { id: 'near', symbol: 'NEAR', name: 'NEAR Protocol' },
  { id: 'vechain', symbol: 'VET', name: 'VeChain' },
  { id: 'optimism', symbol: 'OP', name: 'Optimism' },
  { id: 'immutable-x', symbol: 'IMX', name: 'Immutable' },
  { id: 'maker', symbol: 'MKR', name: 'Maker' },
  { id: 'the-graph', symbol: 'GRT', name: 'The Graph' },
  { id: 'injective-protocol', symbol: 'INJ', name: 'Injective' },
  { id: 'aave', symbol: 'AAVE', name: 'Aave' },
  { id: 'algorand', symbol: 'ALGO', name: 'Algorand' },
  { id: 'fantom', symbol: 'FTM', name: 'Fantom' },
  { id: 'render-token', symbol: 'RNDR', name: 'Render' },
  { id: 'mantle', symbol: 'MNT', name: 'Mantle' },
  { id: 'kaspa', symbol: 'KAS', name: 'Kaspa' },
  { id: 'the-sandbox', symbol: 'SAND', name: 'The Sandbox' },
  { id: 'crypto-com-chain', symbol: 'CRO', name: 'Cronos' },
  { id: 'rocket-pool-eth', symbol: 'RETH', name: 'Rocket Pool ETH' },
  { id: 'quant-network', symbol: 'QNT', name: 'Quant' },
  { id: 'theta-token', symbol: 'THETA', name: 'Theta Network' },
  { id: 'flow', symbol: 'FLOW', name: 'Flow' },
  { id: 'elrond-erd-2', symbol: 'EGLD', name: 'MultiversX' },
  { id: 'axie-infinity', symbol: 'AXS', name: 'Axie Infinity' },
  { id: 'tezos', symbol: 'XTZ', name: 'Tezos' },
  { id: 'eos', symbol: 'EOS', name: 'EOS' },
  { id: 'neo', symbol: 'NEO', name: 'NEO' },
  { id: 'kucoin-shares', symbol: 'KCS', name: 'KuCoin' },
  { id: 'iota', symbol: 'IOTA', name: 'IOTA' },
  { id: 'decentraland', symbol: 'MANA', name: 'Decentraland' },
  { id: 'pancakeswap-token', symbol: 'CAKE', name: 'PancakeSwap' },
  { id: 'gala', symbol: 'GALA', name: 'Gala' },
  { id: 'synthetix-network-token', symbol: 'SNX', name: 'Synthetix Network' },
  { id: 'curve-dao-token', symbol: 'CRV', name: 'Curve DAO' },
  { id: 'enjincoin', symbol: 'ENJ', name: 'Enjin Coin' },
  { id: 'chiliz', symbol: 'CHZ', name: 'Chiliz' },
  { id: 'compound', symbol: 'COMP', name: 'Compound' },
  { id: 'zilliqa', symbol: 'ZIL', name: 'Zilliqa' },
  { id: 'basic-attention-token', symbol: 'BAT', name: 'Basic Attention' },
  { id: '1inch', symbol: '1INCH', name: '1inch' },
  { id: 'yearn-finance', symbol: 'YFI', name: 'yearn.finance' },
  { id: 'sushi', symbol: 'SUSHI', name: 'Sushi' },
  { id: 'loopring', symbol: 'LRC', name: 'Loopring' },
  { id: 'convex-finance', symbol: 'CVX', name: 'Convex Finance' },
  { id: 'helium', symbol: 'HNT', name: 'Helium' },
  { id: 'bancor', symbol: 'BNT', name: 'Bancor Network' },
  { id: 'zcash', symbol: 'ZEC', name: 'Zcash' },
  { id: 'dash', symbol: 'DASH', name: 'Dash' },
  { id: 'decred', symbol: 'DCR', name: 'Decred' },
  { id: 'ravencoin', symbol: 'RVN', name: 'Ravencoin' },
  { id: 'nervos-network', symbol: 'CKB', name: 'Nervos Network' },
  { id: 'harmony', symbol: 'ONE', name: 'Harmony' },
  { id: 'qtum', symbol: 'QTUM', name: 'Qtum' },
  { id: 'ontology', symbol: 'ONT', name: 'Ontology' },
  { id: 'icon', symbol: 'ICX', name: 'ICON' },
  { id: 'waves', symbol: 'WAVES', name: 'Waves' },
  { id: 'komodo', symbol: 'KMD', name: 'Komodo' },
  { id: 'lisk', symbol: 'LSK', name: 'Lisk' },
  { id: 'stratis', symbol: 'STRAX', name: 'Stratis' },
  { id: 'augur', symbol: 'REP', name: 'Augur' },
  { id: 'nano', symbol: 'XNO', name: 'Nano' },
  { id: 'digibyte', symbol: 'DGB', name: 'DigiByte' },
  { id: 'verge', symbol: 'XVG', name: 'Verge' },
  { id: 'steem', symbol: 'STEEM', name: 'Steem' },
  { id: 'status', symbol: 'SNT', name: 'Status' },
  { id: 'zilliqa', symbol: 'ZIL', name: 'Zilliqa' },
  { id: 'horizen', symbol: 'ZEN', name: 'Horizen' },
  { id: 'elastos', symbol: 'ELA', name: 'Elastos' },
  { id: 'ardor', symbol: 'ARDR', name: 'Ardor' }
];
